<!-- /components/modal/Header.vue -->
<template>
  <div class="modal-footer hint">
    <span v-if="uiStore.modalType !== ModalTypes.CONTACT">
      Questions? To use our contact form&nbsp;<a href="" @click.prevent="uiStore.setModalType(ModalTypes.CONTACT)">click here</a>
    </span>    
  </div>
</template>

<script setup>
import { ModalTypes } from '@/types/enums';
import { useUIStore } from '@/store/uiStore';

const uiStore = useUIStore();
</script>

<style lang="scss" scoped>
@import '~/assets/constants.scss';
.dark-mode .modal-footer {
    background: none;
    border-top: 1px solid $fa-orange;
}

.modal-footer {
    background: $fa-orange;
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    padding: 0.25rem;
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 0.875rem;
    color: $light-white;
    margin: 0;
}
</style>
  